var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleCreatePlan4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 87,
    viewBox: "0 0 110 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7461 43.5L45.3096 6.58569V80.4144L23.7461 43.5Z",
    fill: "#FE54F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 43.5L88.4366 6.58569V80.4144L110 43.5Z",
    fill: "#FE54F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3096 6.58569H88.4366V80.4144H45.3096V6.58569Z",
    fill: "#FE54F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 43.5L25.4921 0V87L0 43.5Z",
    fill: "#A4218F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.968 43.5L76.4762 0V87L101.968 43.5Z",
    fill: "#A4218F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4921 0H76.4762V87H25.4921V0Z",
    fill: "#A4218F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9683,
    cy: 23.2232,
    rx: 13.9683,
    ry: 13.8645,
    fill: "#FE54F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1672 70.763H65.4561V59.7134H72.5902V49.9089H65.4561V15.6709H52.5992L29.9429 49.9089V59.7134H54.1672V70.763ZM54.1672 49.9089H41.7022L54.0104 30.9224H54.1672V49.9089Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleCreatePlan4);
export default __webpack_public_path__ + "static/media/titleCreatePlan4.f16c21130458dd4b3bda147234c872f9.svg";
export { ForwardRef as ReactComponent };